// extracted by mini-css-extract-plugin
export default {"Success":"Success___Pjoxv","resourceInfo":"resourceInfo___C5rwn","buttons":"buttons___aq9WW"};